import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import editorReducer, { EDITOR_REDUCER_NAME } from '@Services/Editor';
import userReducer, { USER_REDUCER_NAME, saveUserInLocalStorage } from '@Services/User';
import modalSlice, { MODAL_REDUCER_NAME } from '@Services/Modal';

import commonStatusSlice, { COMMONSTATUS_REDUCER_NAME } from '@Services/CommonStatus';

import projectsReducer, { PROJECTS_REDUCER_NAME, saveProjectsInLocalStorage } from '@Services/Projects';
import { saveEditorListInLocalStorage } from '@Services/EditorList';

const store = configureStore({
  reducer: {
    [USER_REDUCER_NAME]: userReducer,
    [PROJECTS_REDUCER_NAME]: projectsReducer,
    [EDITOR_REDUCER_NAME]: editorReducer,
    [MODAL_REDUCER_NAME]: modalSlice,
    [COMMONSTATUS_REDUCER_NAME]: commonStatusSlice,
  },
  middleware: [thunk, saveUserInLocalStorage, saveProjectsInLocalStorage, saveEditorListInLocalStorage],
});

export default store;
